// AI Widget State Management
const AIWidgetManager = {
  isVisible: true,
  isChatOpen: false,
  lastMessageTime: null,

  // Toggle widget visibility
  toggleVisibility() {
    const button = document.querySelector('#ai-agent-widget-button')
    if (button) {
      this.isVisible = !this.isVisible
      button.style.display = this.isVisible ? 'flex' : 'none'
    }
  },

  // Show widget
  show() {
    const button = document.querySelector('#ai-agent-widget-button')
    if (button) {
      this.isVisible = true
      button.style.display = 'flex'
    }
  },

  // Hide widget
  hide() {
    const button = document.querySelector('#ai-agent-widget-button')
    if (button) {
      this.isVisible = false
      button.style.display = 'none'
    }
  },

  // Check if chat is open
  isChatOpen() {
    return document.querySelector('#ai-agent-chat') !== null
  },

  // Get widget state
  getState() {
    return {
      isVisible: this.isVisible,
      isChatOpen: this.isChatOpen(),
      lastMessageTime: this.lastMessageTime
    }
  },

  // Update last message time
  updateLastMessageTime() {
    this.lastMessageTime = new Date().toISOString()
  },
  
  // Simulate AI typing indicator
  showTypingIndicator() {
    const chat = document.querySelector('#ai-agent-chat')
    if (chat) {
      const messagesArea = chat.querySelector('div[style*="flex: 1"]')
      if (messagesArea) {
        const typingIndicator = document.createElement('div')
        typingIndicator.className = 'ai-typing-indicator'
        typingIndicator.style.cssText = `
          background: white;
          padding: 10px 14px;
          border-radius: 16px;
          margin-bottom: 12px;
          border-left: 3px solid #3b82f6;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          max-width: 80%;
        `
        typingIndicator.innerHTML = `
          <div style="font-weight: 500; color: #374151; margin-bottom: 4px; font-size: 12px;">AI Assistent</div>
          <div style="color: #6b7280; font-size: 13px; line-height: 1.4;">
            <span class="typing-dots">AI schreibt</span>
            <span class="dots">...</span>
          </div>
        `
        messagesArea.appendChild(typingIndicator)
        messagesArea.scrollTop = messagesArea.scrollHeight

        // Animate typing dots
        const dots = typingIndicator.querySelector('.dots')
        let dotCount = 0
        const typingAnimation = setInterval(() => {
          dotCount = (dotCount + 1) % 4
          dots.textContent = '.'.repeat(dotCount)
        }, 500)

        return { typingIndicator, typingAnimation }
      }
    }
    return null
  },

  // Remove typing indicator
  removeTypingIndicator(typingData) {
    if (typingData && typingData.typingIndicator) {
      clearInterval(typingData.typingAnimation)
      typingData.typingIndicator.remove()
    }
  }
}

// Expose to global scope for debugging
window.AIWidgetManager = AIWidgetManager 